import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SupervisorExpenseForm from '../components/SupervisorExpenseForm';
import '../styles/RegisterExpense.css';

const SupervisorRegisterExpense = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState('');

  const handleExpenseAdded = () => {
    // Mostrar mensaje de éxito
    setSuccessMessage('Gasto registrado exitosamente');
    
    // Limpiar el mensaje después de 3 segundos
    setTimeout(() => {
      setSuccessMessage('');
    }, 3000);
  };

  const handleCancel = () => {
    navigate('/supervisor-dashboard');
  };

  const handleBackToDashboard = () => {
    navigate('/supervisor-dashboard');
  };

  return (
    <div className="register-expense-container">
      <header className="register-expense-header">
        <h1>Registro de Gastos - Supervisor</h1>
        <button onClick={handleBackToDashboard} className="back-btn">
          Volver al Dashboard
        </button>
      </header>

      {successMessage && (
        <div className="success-message">
          {successMessage}
        </div>
      )}

      <div className="register-expense-content">
        <SupervisorExpenseForm 
          onExpenseAdded={handleExpenseAdded}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
};

export default SupervisorRegisterExpense;
